var _defs, _path, _path2, _circle, _polygon, _circle2, _polygon2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#ffcdff;stroke-width:12.43px;}.cls-1,.cls-2{stroke-miterlimit:10;}.cls-1,.cls-3{fill:#ff0051;}.cls-2{fill:none;stroke:#47006f;stroke-linecap:round;stroke-width:4px;}.cls-4{fill:#47006f;}.cls-4,.cls-5,.cls-6,.cls-3{stroke-width:0px;}.cls-5{fill:#231f20;}.cls-6{fill:#ffcdff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m427.82,439.73c-59.8,5.91-128.14-21.65-177.82-39.33-49.68,17.69-118.02,45.24-177.82,39.33-5.3-.64-11.27-6.6-11.91-11.91-5.91-59.8,21.64-128.14,39.33-177.82-17.69-49.68-45.24-118.02-39.33-177.82.64-5.32,6.6-11.27,11.91-11.91,59.8-5.91,128.14,21.64,177.82,39.33,49.68-17.69,118.02-45.25,177.82-39.33,5.31.64,11.27,6.6,11.91,11.91,5.91,59.8-21.65,128.14-39.33,177.82,17.68,49.68,45.24,118.02,39.33,177.82-.64,5.31-6.6,11.26-11.91,11.91Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m218.57,303.34c-1.43,0-2.87-.42-4.14-1.28-3.35-2.29-4.22-6.87-1.93-10.22,10.55-15.47,24.64-23.99,39.67-23.99s28.16,7.96,38.56,22.42c2.37,3.3,1.62,7.89-1.67,10.26-3.3,2.37-7.89,1.62-10.26-1.67-7.57-10.51-17.03-16.3-26.63-16.3s-19.79,6.24-27.52,17.57c-1.42,2.09-3.73,3.21-6.08,3.21Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 184.05,
    cy: 260.31,
    r: 18.51
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "155.73 268.37 206.62 236.86 172.4 214.04 155.73 268.37"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 319.9,
    cy: 260.31,
    r: 18.51
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "345.34 268.37 294.45 236.86 328.67 214.04 345.34 268.37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m184.01,271.15s-13.14,25.83-9.97,38.06c3.17,12.23,21.27,9.97,20.38-1.81s-10.41-36.25-10.41-36.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m158.41,267.85s37.51-17.84,45.52-36.78"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m342.84,267.85s-37.51-17.84-45.52-36.78"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes);
export default __webpack_public_path__ + "static/media/eyes.00a2a30152bee0ed2e521e274a1f6743.svg";
export { ForwardRef as ReactComponent };